export function generateExpirationDate(option: { days?: number }): string {
  const date = new Date()
  if (option.days === undefined) {
    return '2100-12-31'
  }
  date.setDate(date.getDate() + option.days)
  return date.toISOString().split('T')[0]
}

export function getExpirationDate(dateString: string): { type: string, value: string} {
  const date = new Date(dateString)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  const finalDate = `${day}/${month}/${year}`
  if (finalDate === '31/12/2100') return { type: 'i18n', value: 'apikey.unlimited'}
  return { type: 'data', value: finalDate}
}
